import React from "react";
import { useSearchParams } from "react-router-dom";
import { Factory, PlayCircle, Settings2 } from "lucide-react";
import { PageHeader } from "../lib/ui";
import { useT } from "../lib/i18n";
import { ProductionWorkflow } from "./CentralProduction";
import Production from "./Production";

// SINGLE Central Production workspace. One menu, one workspace, one engine.
// Tab 1 (default): the guided operational Production Workflow (reuses ProductionWorkflow).
// Tab 2: the existing Production Engine module (reuses Production page, embedded — no duplication).
export default function CentralProductionWorkspace() {
  const { t } = useT();
  const [sp, setSp] = useSearchParams();
  const view = sp.get("view") === "engine" ? "engine" : "workflow";
  const setView = (v) => setSp(v === "workflow" ? {} : { view: v });

  const TABS = [
    { key: "workflow", label: t("Production Workflow"), icon: PlayCircle },
    { key: "engine", label: t("Production Engine"), icon: Settings2 },
  ];

  return (
    <div className="animate-fade-up space-y-5 pb-24 lg:pb-2" data-testid="central-production-workspace">
      <PageHeader title={t("Central Production")} subtitle={t("One production workspace — daily operational flow + the full production engine.")} icon={Factory} />
      <div className="flex flex-wrap gap-2" data-testid="cpws-tabs">
        {TABS.map((tb) => (
          <button key={tb.key} onClick={() => setView(tb.key)} data-testid={`cpws-tab-${tb.key}`}
            className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-all ${view === tb.key ? "bg-primary text-white" : "bg-white border border-line text-ink-soft hover:bg-stone-50"}`}>
            <tb.icon size={16} /> {tb.label}
          </button>
        ))}
      </div>
      {view === "workflow" ? <ProductionWorkflow embedded /> : <Production embedded />}
    </div>
  );
}
